import * as React from 'react';
import ModalContact from '../../src/containers/Contact/index';

export default (props) => <ModalContact {...props} />
